"use client";
import { ProfileAvatar } from "../../ui/profile-avatar";
import { InfoTooltip } from "../../ui/info-tooltip";
import { courseInitials } from "./course-people.utils";
import { COURSE_AVATAR, COURSE_PEOPLE } from "./course-people.constants";
import type { CourseAvatarGroupProps } from "./course-people.types";

export function CourseAvatarGroup({
  instructors,
  label,
}: CourseAvatarGroupProps) {
  if (!instructors.length) return null;
  const remaining = instructors.slice(COURSE_PEOPLE.visibleCount);
  return (
    <div
      role="group"
      aria-label={label}
      className="relative z-20 flex -space-x-1.5"
    >
      {instructors.slice(0, COURSE_PEOPLE.visibleCount).map((person, index) => (
        <InfoTooltip
          key={`${person.name}-${index}`}
          content={person.name}
          align="left"
          position="top"
          contentClassName="w-max max-w-56"
          trigger={
            <button
              type="button"
              aria-label={person.name}
              className="rounded-full outline-offset-2 focus-visible:outline focus-visible:outline-primary"
            >
              <ProfileAvatar
                src={person.image_url}
                alt={person.name}
                fallback={courseInitials(person.name)}
                className={`h-9 w-9 ring-2 ring-white text-xs ${COURSE_AVATAR.border}`}
                fallbackClassName={COURSE_AVATAR.fallback}
              />
            </button>
          }
        />
      ))}
      {remaining.length > 0 && (
        <InfoTooltip
          content={remaining.map((person) => person.name).join(", ")}
          trigger={
            <button
              type="button"
              aria-label={remaining.map((person) => person.name).join(", ")}
              className={`flex h-9 w-9 items-center justify-center ring-2 ring-white text-xs ${COURSE_AVATAR.border} ${COURSE_AVATAR.fallback}`}
            >
              +{remaining.length}
            </button>
          }
        />
      )}
    </div>
  );
}
